import type { QueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import type { TFunction } from 'i18next';
import { postWithCSRF } from './axiosWithCSRF';
import { envApiUrl } from './envApiUrl';
import type { MydayType } from './useMyday';

interface UserType {
  id: number;
}
interface HandleCreateMydayProps {
  data: any;
  user: UserType;
  queryClient?: QueryClient;
  onOk?: (res: MydayType) => void;
  withConfirmation?: boolean;
  t: TFunction;
}

export const handleCreateMyday = async ({
  data,
  user,
  queryClient,
  onOk,
  withConfirmation,
  t,
}: HandleCreateMydayProps) => {
  console.log('handleCreateMyday data', data);
  if (!user.id) return {};

  try {
    const response = await postWithCSRF(
      envApiUrl + '/mydays',
      { ...data, status: 'draft' },
      {
        headers: {
          userId: user.id,
        },
      },
    );
    console.log('Created Myday: response: ', response);
    if (withConfirmation) {
      message.success(t('myday.mydayDraftCreated'));
    }

    // Invalidate mydays query to refresh the list
    if (queryClient) {
      queryClient.invalidateQueries({ queryKey: ['useMydays'] });
    }

    onOk?.(response.data);
    return response.data;
  } catch (err: any) {
    console.error('handleCreateMyday error: ', err.response?.data?.message, err);
    message.error(err.response?.data?.message || t('myday.mydayCreateFailed'));
  }
};
